import { useId } from 'react';

import { SettingRow } from '@/components/ui/settings-panel';
import { Switch } from '@/components/ui/switch';
import { FEATURE_FLAGS, useFeatures } from '@/hooks/useFeatures';
import { useWebSearchDefault } from '@/hooks/useWebSearchDefault';

export function WebSearchDefault() {
  const { isEnabled: webResearchEnabled } = useFeatures(FEATURE_FLAGS.WEB_RESEARCH);
  const { enabled, save } = useWebSearchDefault();
  const switchId = useId();

  if (!webResearchEnabled) return null;

  return (
    <SettingRow
      htmlFor={switchId}
      label="Web search by default"
      description="When selected, Case Partner's web search capability is enabled for new chats by default. You can still turn it off for a single conversation."
    >
      <div className="flex h-9 items-center">
        <Switch
          id={switchId}
          checked={enabled}
          aria-label="Web search by default"
          onCheckedChange={save}
        />
      </div>
    </SettingRow>
  );
}
